import React from "react";
import { cn } from "../../../lib/utils";

interface InvestmentTabsProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
}

const tabs = [
    { id: "overview", label: "Overview" },
    { id: "financials", label: "Financials" },
    { id: "assets", label: "Assets Needed" },
    { id: "media", label: "Media" },
    { id: "market", label: "Market" },
];

const InvestmentTabs: React.FC<InvestmentTabsProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="sticky top-0 z-40 bg-background/90 backdrop-blur-md pt-4 pb-2 px-4 overflow-x-auto no-scrollbar border-b border-border shadow-sm">
            <div className="flex space-x-8 min-w-max">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={cn(
                            "relative pb-3 text-sm transition-colors",
                            activeTab === tab.id
                                ? "font-bold text-primary"
                                : "font-semibold text-muted-foreground hover:text-foreground"
                        )}
                    >
                        {tab.label}
                        {activeTab === tab.id && (
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-primary rounded-t-full" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default InvestmentTabs;
